<script>
  import config from '../../libs/config.js';
	  import api from '../../api'
	import { mapGetters, mapActions } from 'vuex'
	
	export default 
	{
		name: 'IntroductionPage',
		data() 
        {
        	return {
            config: config,
            teammateModal: false,
            teammates: []
        	}
        },
        computed: {
          ...mapGetters('session', ['isLoggedIn', 'getUser', 'getJwt']),
          ...mapGetters('workspaces', ['currentWorkspace']),
          ...mapGetters('loading', ['loadingApp']),
        },
      methods: {
        ...mapActions('session', ['setUser']),
      },
        created(){
          setTimeout(() => {
          console.log(this.currentWorkspace);
          }, 2000)
        }
	}
</script>

<template>
  <div v-if="!loadingApp" class="ui grid centered middle aligned stackable">
    <div data-aos="zoom-in" class="nine wide column">
      <table>
        <tbody>
          <tr>
            <td style="padding-right: 1rem;opacity: 0.2;" data-label="Name"> <b>Step 1</b> - Create Online Workspace</td>
            <td style="padding-right: 1rem; opacity: 0.2;" data-label="Name"><b>Step 2</b> - Setup Team</td>
            <td style="padding-right: 1rem; " data-label="Name"><b>Step 3</b> - Connect Social Accounts 🚀</td>
          </tr>
        </tbody>
      </table>
   <div class="ui divider"></div>
      <div class="ui basic large segment">
        <h2>You are almost done! 🤩 </h2>
        <p>Just connect your channels to complete your setup!</p>
 


             <form id="auth" :action="'https://graph.facebook.com/oauth/authorize'" method="get">

                <input type="text" name="state" :value="JSON.stringify({'userId':getUser._id,'workspaceId': currentWorkspace._id })" hidden>

                <input type="text" name="client_id" :value="'220505862059842'" hidden>
                
                <input type="text" name="redirect_uri" :value="config.url + '/facebook/redirect'" hidden>

                <input type="text" name="response_type" :value="'code'" hidden>

                <input type="text" name="access_type" :value="'offline'" hidden>

                <input type="text" name="prompt" :value="'consent'" hidden>

                <input type="text" name="scope" :value="'manage_pages,pages_messaging,publish_pages,ads_management'" hidden>


                  <button style="text-align: left;" type="submit" value="Submit" class="ui facebook large button fluid">
                                      <i class="facebook icon"></i>
                  Facebook <span style="margin-left: 4px;font-style: italic; font-size: 12px; font-weight: 400;">  Page's Comments, Direct Messages, Ads Comments (Dark Post)</span>
                  </button>
            </form>

<!--             <form  :action=" config.url + '/facebook/auth'" method="post">
              <input type="text" name="accessToken" v-model="getJwt" hidden>
              <input type="text" name="workspaceId" v-model="currentWorkspace._id" hidden>
                  <button style="text-align: left;" type="submit" value="Submit" class="ui facebook large button fluid">
                                      <i class="facebook icon"></i>
                  Facebook <span style="margin-left: 4px;font-style: italic; font-size: 12px; font-weight: 400;">  Page's Comments, Direct Messages</span>
                  </button>
          </form> -->
<br>
     <form id="auth" class="ui form" :action="'https://graph.facebook.com/oauth/authorize'" method="get">

                <input type="text" name="state" :value="JSON.stringify({'userId':getUser._id,'workspaceId': currentWorkspace._id })" hidden>

                <input type="text" name="client_id" :value="'220505862059842'" hidden>
                
                <input type="text" name="redirect_uri" :value="config.url + '/instagram/redirect'" hidden>

                <input type="text" name="response_type" :value="'code'" hidden>

                <input type="text" name="access_type" :value="'offline'" hidden>

                <input type="text" name="prompt" :value="'consent'" hidden>

                <input type="text" name="scope" :value="'manage_pages, pages_messaging, publish_pages, instagram_basic, instagram_manage_comments, ads_management'" hidden>

                  <button style="background: rgba(0, 0, 0, 0) url('/img/social/instagram-background.jpg') repeat scroll 0% 0% / cover;text-align: left;" type="submit" value="Submit" class="ui facebook large button fluid">
                                      <i class="instagram icon"></i>
                  Instagram <span style="margin-left: 4px;font-style: italic; font-size: 12px; font-weight: 400;">  Comments, @Mentions</span>
                  </button>
          </form>
<br>
              <form class="ui form" :action=" config.url + '/twitter/auth'" method="post">
                <input type="text" name="accessToken" v-model="getJwt" hidden>
                <input type="text" name="workspaceId" v-model="currentWorkspace._id" hidden>
                    <button style="text-align: left;" type="submit" value="Submit" class="ui twitter large button fluid">                  <i class="twitter icon"></i>
                  Twitter <span style="margin-left: 4px;font-style: italic; font-size: 12px; font-weight: 400;">  Mentions, Direct Messages, Monitoring By Keyword</span></button>
            </form>
<!-- <br>
                        <form class="ui form" :action=" config.url + '/youtube/auth'" method="post">
                <input type="text" name="accessToken" v-model="getJwt" hidden>
                <input type="text" name="workspaceId" v-model="currentWorkspace._id" hidden>
                    <button disabled style="text-align: left;" type="submit" value="Submit" class="ui youtube large button fluid">                  <i class="youtube icon"></i>
                  YouTube <span style="margin-left: 4px;font-style: italic; font-size: 12px; font-weight: 400;">  Comments</span></button>
            </form> -->
           
<br>
            <a href="/" style="background: transparent;" class="ui button right floated">Jump to dashboard <i class="long arrow alternate right icon"></i> </a>

<!-- 
                    <div class="ui hidden divider"></div>
          <p>
          <span style="color:#aaa;font-style: italic; font-size: 12px; font-weight: 400;">Available Soon...</span>
          <button style="text-align: left;" class="ui instagram button fluid disabled">
            <i class="linkedin icon"></i>
            Linkedin <span style="margin-left: 4px;font-style: italic; font-size: 12px; font-weight: 400;">  Comments, Direct Messages</span>
          </button>
          </p>
          <p>
          <button style="text-align: left;" class="ui google button fluid disabled">
            <i class="google icon"></i>
            Gmail <span style="margin-left: 4px;font-style: italic; font-size: 12px; font-weight: 400;">  Multiple Emails</span>
          </button>
          </p>
          <p>
          <button style="text-align: left; background: #37D950;" class="ui inverted button fluid disabled">
            <i class="whatsapp icon"></i>
            WhatsApp <span style="margin-left: 4px;font-style: italic; font-size: 12px; font-weight: 400;">  Messages</span>
          </button>
          </p> -->
      </div>
    </div>

  </div>

</template>



// WEBPACK FOOTER //
// src/components/dashboard/introductionPage.vue